import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from '../../avatar.component';
import { cn } from '../../../../lib/utils';

@Component({
  selector: 'app-avatar-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar-image.component.html',
})
export class AvatarImageComponent {
  private avatar = inject(AvatarComponent);

  @Input() src: string | undefined;
  @Input() alt: string = '';
  @Input() className: string = '';

  get classes() {
    return cn('aspect-square h-full w-full', this.className);
  }

  onImageError() {
    this.avatar.showFallback.set(true);
  }

  onImageLoad() {
    this.avatar.showFallback.set(false);
  }
}
